import {Injectable, Injector, inject} from "@angular/core";
import {component, EntityData, EntityModel, field, identifier} from "@fedelta-pos/data-client";
import {AppDeviceType} from '../configuration/configuration.model';

export class LocationData extends EntityData<LocationData> {
    @identifier locationId: number;
    @field locationName: string;
    @field stripeLocationIdTestMode: string;
    @field stripeLocationIdLiveMode: string;
}

export class AppDeviceData extends EntityData<AppDeviceData> {
    @identifier deviceId: number;
    @field name: string;
    @field deviceType: AppDeviceType;
    @field stripeLocationId: string;
    @field liveMode: boolean;
    @field registered: boolean;
    @field discontinued: boolean;
    @component location: LocationData;
}

/**
 * Readonly entity model to access AppDeviceData. AppDeviceData represents the logical config of an
 * App Device registered on the server
 */
@Injectable()
export class AppDeviceEntityModel extends EntityModel<AppDeviceData> {
    constructor() {
        console.log("--- AppDeviceEntityModel");
        super(inject(Injector), AppDeviceData);
    }
}
